module.exports = __webpack_public_path__ + "static/media/completed-icon-card.6978fc55.svg";